<template>
  <div class="log">
    <button
      v-permissions="'view-details-jobs'"
      @click.stop="dialog = false"
      @click="getAssignments"
      title="View Address"
      target="_blank"
      class="view-ass-btn"
    >
      View
    </button>

    <v-dialog
      v-model="dialog"
      max-width="56rem"
      content-class="sales-address-dialog"
      persistent
    >
      <v-form ref="form">
        <v-card class="sales-address-card">
          <header class="sales-address-header">
            <div class="sales-address-header__brand">
              <div class="sales-address-header__badge" aria-hidden="true">
                <v-icon>place</v-icon>
              </div>
              <h2 class="sales-address-title">View Address Details</h2>
            </div>
            <v-btn
              icon
              class="sales-address-close"
              @click.prevent="dialog = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>

          <div class="sales-address-body">
            <v-data-table
              id="salesAddressTable"
              class="sales-address-table"
              hide-actions
              :headers="headers"
              :items="items"
            >
              <template slot="items" slot-scope="props">
                <td class="sales-address-sr">{{ props.index + 1 }}</td>
                <td>
                  <span
                    class="sales-address-type-chip"
                    :class="`sales-address-type-chip--${getJobType(props.item.jobType).toLowerCase()}`"
                  >
                    {{ getJobType(props.item.jobType) }}
                  </span>
                </td>
                <td class="sales-address-text">
                  {{ props.item.sourceLocation }}
                </td>
                <td class="sales-address-text">
                  {{ props.item.destinationLocation }}
                </td>
              </template>
            </v-data-table>
            <div
              v-if="!processing && (!items || !items.length)"
              class="sales-address-empty"
            >
              No address details found.
            </div>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="6000"
      bottom
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
    >
      {{ x.error }}
    </v-snackbar>
  </div>
</template>
<script>
import moment from "moment";
import { salesAddressList } from "@/constants/datatable-headers.js";
import ErrorBox from "@/components/Common/ErrorBox";
import { StorageKeys } from "../../constants/constants";
import { salesSectionApiUrl } from "../../constants/api-urls";
export default {
  data() {
    return {
      x: {
        error: null,
      },
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      headers: salesAddressList,
    };
  },
  props: {
    inquiryId: String,
  },
  created() {},
  components: {
    ErrorBox,
  },
  methods: {
    getJobType(type) {
      switch (type) {
        case 1:
          return "Land";
        case 2:
          return "Air";
        case 3:
          return "Sea";
        default:
          return "Land";
      }
    },
    getTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },

    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded ";
        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    getAssignments() {
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }

      this.dialog = true;
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        let url = salesSectionApiUrl.viewInquiryAddress;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          inquiryId: this.inquiryId.toString(),
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.dialog = true;
            this.items = response.data.data[0].subJobList;

            this.processing = false;
          },
          (error) => {
            this.x.error = "Failed to Fetch Assignments";
            this.processing = false;
          }
        );
      }
    },
  },
};
</script>
<style>
.application .v-dialog.sales-address-dialog {
  border-radius: 1rem !important;
  max-width: min(56rem, calc(100vw - 2rem)) !important;
  min-width: min(36rem, calc(100vw - 2rem)) !important;
  overflow: hidden !important;
  width: min(56rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.sales-address-dialog .sales-address-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: none !important;
  overflow: hidden;
  padding: 0 !important;
}

.application .v-dialog.sales-address-dialog .v-toolbar,
.application .v-dialog.sales-address-dialog .v-card__title {
  background: transparent !important;
  border-bottom: 0 !important;
}

.application
  .v-dialog.sales-address-dialog
  .sales-address-table
  table.v-table
  thead
  th,
.application
  .v-dialog.sales-address-dialog
  #salesAddressTable
  th,
.application
  .v-dialog.sales-address-dialog
  .sales-address-table
  table.v-table
  thead
  th.table-header-item,
.application
  .v-dialog.sales-address-dialog
  .sales-address-table
  table.v-table
  thead
  th
  span {
  background: #ea7a1c !important;
  border-bottom: 0.0625rem solid #d96a10 !important;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em !important;
  opacity: 1 !important;
  text-align: left !important;
  text-transform: uppercase;
}

.application
  .v-dialog.sales-address-dialog
  .sales-address-table
  table.v-table
  thead
  th:first-child,
.application
  .v-dialog.sales-address-dialog
  .sales-address-table
  table.v-table
  tbody
  td:first-child,
.application .v-dialog.sales-address-dialog .sales-address-sr {
  text-align: left !important;
}
</style>
<style scoped>
.view-ass-btn {
  align-items: center;
  background-color: #fff7ed;
  border: 0.0625rem solid #ea7a1c;
  border-radius: 0.5rem;
  color: #c35f02;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  min-height: 2rem;
  padding: 0.375rem 0.75rem;
  text-decoration: none;
  text-transform: none;
}

.sales-address-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.sales-address-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.sales-address-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.sales-address-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.sales-address-title {
  color: #1c2b5f;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin: 0;
}

.sales-address-close {
  color: #74716a !important;
  height: 2rem !important;
  margin: 0 !important;
  width: 2rem !important;
}

.sales-address-close .v-icon {
  color: #74716a !important;
}

.sales-address-body {
  max-height: min(62vh, 30rem);
  overflow: auto;
  padding: 0.85rem 1rem 1rem;
  scrollbar-width: thin;
}

.sales-address-empty {
  color: #8a857c;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 1.5rem 0.5rem;
  text-align: center;
}

.sales-address-table ::v-deep .v-table__overflow {
  border: 0.0625rem solid #ebe9e2;
  border-radius: 0.75rem;
  overflow-x: auto !important;
}

.sales-address-table ::v-deep table.v-table {
  min-width: 0 !important;
  table-layout: fixed;
  width: 100% !important;
}

.sales-address-table ::v-deep table.v-table thead th {
  background: #ea7a1c !important;
  border-bottom: 0.0625rem solid #d96a10 !important;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  height: 2.5rem;
  letter-spacing: 0.03em;
  padding: 0.55rem 0.75rem !important;
  text-align: left !important;
  text-transform: uppercase;
}

.sales-address-table ::v-deep table.v-table tbody td {
  border-bottom: 0.0625rem solid #f3f1eb !important;
  color: #3a382f;
  font-size: 0.8125rem !important;
  line-height: 1.45;
  padding: 0.75rem !important;
  text-align: left !important;
  vertical-align: top;
}

.sales-address-table ::v-deep table.v-table th:first-child,
.sales-address-table ::v-deep table.v-table td:first-child {
  text-align: left !important;
  width: 4.75rem;
}

.sales-address-table ::v-deep table.v-table th:nth-child(2),
.sales-address-table ::v-deep table.v-table td:nth-child(2) {
  text-align: left !important;
  width: 6.5rem;
}

.sales-address-table ::v-deep table.v-table th:nth-child(3),
.sales-address-table ::v-deep table.v-table td:nth-child(3),
.sales-address-table ::v-deep table.v-table th:nth-child(4),
.sales-address-table ::v-deep table.v-table td:nth-child(4) {
  width: calc((100% - 11.25rem) / 2);
}

.sales-address-sr {
  color: #8a857c;
  font-weight: 800;
  text-align: left !important;
}

.sales-address-type-chip {
  background: #fff7ed;
  border: 0.0625rem solid #fed7aa;
  border-radius: 999px;
  color: #c35f02;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1;
  padding: 0.35rem 0.55rem;
  text-transform: uppercase;
}

.sales-address-type-chip--air {
  background: #eaf1fd;
  border-color: #d3e1fb;
  color: #2456b8;
}

.sales-address-type-chip--sea {
  background: #e8f5ee;
  border-color: #cde9da;
  color: #12764c;
}

.sales-address-text {
  overflow-wrap: anywhere;
  text-align: left !important;
  white-space: normal;
  word-break: normal;
}

@media (max-height: 32rem) {
  .sales-address-body {
    max-height: calc(100vh - 10rem);
  }
}
</style>
